export function entryBooking(entry, isToday) {
  const booking = isToday ? entry.currentBooking : entry.dayBooking
  return !booking || booking.status === 'cancelled' ? null : booking
}

export function entryExternallyOccupied(entry, isToday) {
  if (entryBooking(entry, isToday)) return false
  return isToday
    ? entry.occupiedNow === true
    : (entry.externalBlocks?.length || 0) > 0
}

export function entryOccupied(entry, isToday) {
  return Boolean(entryBooking(entry, isToday)) || entryExternallyOccupied(entry, isToday)
}
